module.exports = __webpack_public_path__ + "static/media/helbiz.1b5e7b3c.svg";